var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { launch } from "./state";
import { onRouteChange } from "./router";
import "./components/launch-gate";
import "./components/ip-protect";
import "./routes/case-view";
import "./routes/batch-view";
import "./routes/pas-activity-view";
import "./routes/pas-patient-view";
let EhrApp = class EhrApp extends SignalWatcher(LitElement) {
    constructor() {
        super(...arguments);
        this.route = { name: "home" };
        this._stopRoute = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this._stopRoute = onRouteChange((r) => { this.route = r; });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._stopRoute) {
            this._stopRoute();
            this._stopRoute = null;
        }
    }
    render() {
        if (!launch.value) {
            return html `<launch-gate></launch-gate>`;
        }
        return html `
      <ip-protect></ip-protect>
      ${this._renderRoute()}
    `;
    }
    _renderRoute() {
        const r = this.route;
        switch (r.name) {
            case "case":
                return html `<case-view .scenarioId=${r.id}></case-view>`;
            case "batch":
                return html `<batch-view .batchId=${r.id}></batch-view>`;
            case "pas-activity":
                return html `<pas-activity-view .activityId=${r.id}></pas-activity-view>`;
            case "pas-patient":
                return html `<pas-patient-view .patientId=${r.id}></pas-patient-view>`;
            default:
                return html `<p>Welcome to TalentMed EHR Simulator. Launch from your LMS.</p>`;
        }
    }
};
__decorate([
    state()
], EhrApp.prototype, "route", void 0);
EhrApp = __decorate([
    customElement("ehr-app")
], EhrApp);
export { EhrApp };
